export class Validator {

    result: boolean;
    title: string;
    message: string;

    constructor() {}

}
